import React from 'react';
import config from 'config';
import { StyledMenu, StyledMenuItem } from './styled';
import { injectIntl } from 'react-intl';

import { getClientConfig, constants } from 'redux/modules/client-config/selectors';
import { useSelector } from 'react-redux';
import { IS_TENANT } from 'tenant/config';

const Menu = ({ intl }) => {
  const t = intl.messages.modules.Menu;
  const TABS = useSelector((store) => getClientConfig(store, constants.TABS));

  return (
    <StyledMenu>
      {TABS[constants.LAST_MILE_DASHBOARD_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}last-mile/dashboard`}>
          {t.dashboard}
        </StyledMenuItem>
      )}
      {TABS[constants.LAST_MILE_SHIPMENTS_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}last-mile/shipments`}>
          {t.shipments}
        </StyledMenuItem>
      )}
      {TABS[constants.LAST_MILE_ISSUES_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}last-mile/issues`}>{t.issues}</StyledMenuItem>
      )}
      {TABS[constants.FLEET_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}fleet`}>{t.fleet}</StyledMenuItem>
      )}
      {/*
        for tenant tab is enabled because we need to go to /queued/14
        but we don´t want to show the menu button
      */}
      {TABS[constants.QUEUED_TAB] && !IS_TENANT && (
        <StyledMenuItem to={`${config.BASE_ROUTE}queued`}>{t.queued}</StyledMenuItem>
      )}
      {TABS[constants.JOBS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}jobs`}>{t.jobs}</StyledMenuItem>
      )}
      {TABS[constants.TASKS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}tasks`}>{t.tasks}</StyledMenuItem>
      )}
      {TABS[constants.EMERGENCIES_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}emergencies`}>{t.emergencies}</StyledMenuItem>
      )}
      {TABS[constants.SHIPPERS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}shipper`}>{t.shippers}</StyledMenuItem>
      )}
      {TABS[constants.DOCS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}docs`}>{t.Docs}</StyledMenuItem>
      )}
      {TABS[constants.CARRIERS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}carrier`}>{t.carriers}</StyledMenuItem>
      )}
      {TABS[constants.VEHICLES_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}vehicle`}>{t.vehicles}</StyledMenuItem>
      )}
      {TABS[constants.PREBOOKINGS_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}prebookings`}>{t.prebookings}</StyledMenuItem>
      )}
      {TABS[constants.DELEGATION_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}delegation`}>{t.delegation}</StyledMenuItem>
      )}
      {TABS[constants.USERS_MANAGEMENT_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}user-management/groups`}>{t.roles}</StyledMenuItem>
      )}
      {TABS[constants.USERS_MANAGEMENT_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}user-management/users`}>{t.users}</StyledMenuItem>
      )}
      {TABS[constants.COPILOT_TAB] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}copilot`}>{t.copilot}</StyledMenuItem>
      )}
      {TABS[constants.PRICING_CONSOLE_MODULE_ENABLED] && (
        <StyledMenuItem to={`${config.BASE_ROUTE}pricing-console`}>
          {t.pricingConsole}
        </StyledMenuItem>
      )}
    </StyledMenu>
  );
};

export default injectIntl(Menu);
